function limitPrecision(n: number, precision = 10) {
  const max = 10 ** precision;
  return Math.round(n * max) / max;
}

export default limitPrecision;
